module.exports = __webpack_public_path__ + "img/white_ham_menu.ca4ede47.svg";